import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import { IFile } from 'coreOld/types';
import { uniqueArrayByKeys } from 'coreOld/utils';

import FileDropzoneView from './FileDropzoneView';

interface IProps {
  files?: IFile[];
  onFileDrop: (files: IFile[]) => void;
  onRemoveFile?: (file: IFile) => void;
  acceptedFileTypes?;
  maxFiles?: number;
}

const ACCEPTED_FILE_TYPES = {};
const MAX_FILES = 20;

const FileDropzone = ({
  files,
  onFileDrop,
  onRemoveFile,
  acceptedFileTypes = ACCEPTED_FILE_TYPES,
  maxFiles = MAX_FILES,
}: IProps) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      onFileDrop(uniqueArrayByKeys([...files, ...acceptedFiles], ['fileName', 'path']));
    },
    [onFileDrop, files]
  );

  const accept = acceptedFileTypes ? { accept: acceptedFileTypes } : {};

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop,
    maxFiles,
    ...accept,
  });

  return (
    <FileDropzoneView
      files={files}
      onRemoveFile={onRemoveFile}
      getRootProps={getRootProps}
      getInputProps={getInputProps}
      isDragActive={isDragActive}
      isDragAccept={isDragAccept}
      isDragReject={isDragReject}
    />
  );
};

export default FileDropzone;
